// Author Liang Gangqiang
// Date 2021-08-12 10:09:47

class SithMesRitaCamera {
constructor({
        id = null,
        name = '',
        account = '',
        password = '',
        ipAddress = '',
        channelName = '',
        rtmpAddress = '',
        remark = '',
        alive = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.account = account;
    this.password = password;
    this.ipAddress = ipAddress;
    this.channelName = channelName;
    this.rtmpAddress = rtmpAddress;
    this.remark = remark;
    this.alive = alive;
}
}

function newEntity() {
return new SithMesRitaCamera();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.rita.sithMesRitaCamera.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.sith.rita.sithMesRitaCamera.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'account',
        label: 'label.sith.rita.sithMesRitaCamera.grid.account',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'password',
        label: 'label.sith.rita.sithMesRitaCamera.grid.password',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ipAddress',
        label: 'label.sith.rita.sithMesRitaCamera.grid.ipAddress',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'channelName',
        label: 'label.sith.rita.sithMesRitaCamera.grid.channelName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'rtmpAddress',
        label: 'label.sith.rita.sithMesRitaCamera.grid.rtmpAddress',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.rita.sithMesRitaCamera.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'alive',
        label: 'label.sith.rita.sithMesRitaCamera.grid.alive',
        sortable: true,
        form: {
        type: 'boolean'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    nameFilter : "",
    accountFilter : "",
    passwordFilter : "",
    ipAddressFilter : "",
    channelNameFilter : "",
    rtmpAddressFilter : "",
    aliveFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.sith.rita.sithMesRitaCamera.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'accountFilter',
        label: 'label.sith.rita.sithMesRitaCamera.filter.account',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'passwordFilter',
        label: 'label.sith.rita.sithMesRitaCamera.filter.password',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'ipAddressFilter',
        label: 'label.sith.rita.sithMesRitaCamera.filter.ipAddress',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'channelNameFilter',
        label: 'label.sith.rita.sithMesRitaCamera.filter.channelName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'rtmpAddressFilter',
        label: 'label.sith.rita.sithMesRitaCamera.filter.rtmpAddress',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'aliveFilter',
        label: 'label.sith.rita.sithMesRitaCamera.filter.alive',
        disabled: false,
        form: {
        type: 'boolean'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.sith.rita.sithMesRitaCamera.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'account',
        label: 'label.sith.rita.sithMesRitaCamera.entity.account',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'password',
        label: 'label.sith.rita.sithMesRitaCamera.entity.password',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'ipAddress',
        label: 'label.sith.rita.sithMesRitaCamera.entity.ipAddress',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'channelName',
        label: 'label.sith.rita.sithMesRitaCamera.entity.channelName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'rtmpAddress',
        label: 'label.sith.rita.sithMesRitaCamera.entity.rtmpAddress',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.rita.sithMesRitaCamera.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'alive',
        label: 'label.sith.rita.sithMesRitaCamera.entity.alive',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean'
                }
        }
]

export {SithMesRitaCamera, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
